export enum WorkflowPhase {
  AppointmentConfirmation = "appointment_confirmation",
  AppointmentRescheduling = "appointment_rescheduling",
  AppointmentScheduling = "appointment_scheduling",
  Complete = "complete",
  IntentVerification = "intent_verification",
  PatientIntake = "patient_intake",
}

export enum PatientStatus {
  Unknown = "unknown",
  New = "new",
  Established = "established",
}

export enum Intent {
  Billing = "billing",
  CancelAppointment = "cancel_appointment",
  ConfirmAppointment = "confirm_appointment",
  NonActionable = "non_actionable",
  NonScheduling = "non_scheduling",
  PatientIntake = "patient_intake",
  PrescriptionRefill = "prescription_refill",
  ProviderTransfer = "provider_transfer",
  Reschedule = "reschedule",
  ScheduleExisting = "schedule_existing",
  ScheduleInitial = "schedule_initial",
  Csat = "csat",
  Faq = "faq",
  // Caller wants to leave a message for staff; routed through patient lookup, then the telephone-encounter workflow.
  LeaveMessage = "leave_message",
  // This is used to route to a specific line when callers request a representative from the get-go and not during some other workflow.
  TransferCallToRepresentative = "transfer_call_to_representative",
  Unconfirmed = "unconfirmed",
}

export type EstablishedPatientPolicyOptions = {
  // When true, the established-patient task requires recordApproximateDate to
  // be called (with caller confirmation) before existingAppointmentLookup runs.
  requiresTimelineConfirmation: boolean;
};
